<template>
  <div
    class="custom-control custom-checkbox d-flex order-item"
    v-bind:class="{
      'jobedit-open': selectedJob ? selectedJob.item.id === item.id : '',
      'z-index-detail': statusDropdownOpen,
    }"
  >
    <div id="order-item-detail" class="flex-grow-1">
      <div class="rd-deep-1" :class="visible ? 'expanded' : ''">
        <b-container fluid>
          <b-row>
            <b-col cols="4" class="d-flex align-items-center" style="min-height: 100px;">
              <div class="rdd1-part--with-icon">
                <div class="rdd1-part rdd1-part__icon">
                  <b-button
                    variant="icon"
                    @click="visible = !visible"
                    class="btn-icon--collapse"
                    :class="visible ? '' : 'collapsed'"
                    v-if="hasMoreDetails"
                  >
                    <i class="di-arrow-down-12 when-closed"></i>
                    <i class="di-arrow-up-12 when-opened"></i>
                  </b-button>
                </div>
                <div class="rdd1-part__content">
                  <div class="font-weight-medium">{{ productName }}</div>
                  <div v-if="isLensUpgraded && lensUpgradeReason" class="mt-1">
                    <div class="upgrade-badge-container" style="position: relative; display: inline-block;">
                      <b-badge
                        variant="warning"
                        @mouseenter="showTooltip = true"
                        @mouseleave="showTooltip = false"
                        style="cursor: help;"
                      >
                        UPGRADED
                      </b-badge>
                      <div
                        v-if="showTooltip"
                        class="custom-tooltip"
                        style="
                          position: absolute;
                          bottom: 100%;
                          left: 50%;
                          transform: translateX(-50%);
                          background: #333;
                          color: white;
                          padding: 8px 12px;
                          border-radius: 4px;
                          font-size: 12px;
                          z-index: 1000;
                          margin-bottom: 5px;
                          box-shadow: 0 2px 8px rgba(0,0,0,0.3);
                          width: 300px;
                          white-space: normal;
                          word-wrap: break-word;
                          text-align: center;
                        "
                      >
                        {{ lensUpgradeReason }}
                        <div style="
                          position: absolute;
                          top: 100%;
                          left: 50%;
                          transform: translateX(-50%);
                          border: 5px solid transparent;
                          border-top-color: #333;
                        "></div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <small class="text-muted">{{ productOptions }}</small>
                  </div>
                  <div>
                    <small class="text-muted">Order Item ID: {{ orderItemID }}</small>
                  </div>
                  <div v-if="historicalDataPurpose">
                    <small class="text-muted"
                      >Purpose: {{ historicalDataPurpose.toUpperCase() }}</small
                    >
                  </div>

                  <div v-if="isOctoposOrder">
                    <small class="text-muted">Item Price: ${{ orderItemPrice.toFixed(2) }}</small>
                  </div>

                  <div v-if="Ismiscellaneous">
                    <small class="text-muted">Detail: {{ miscellaneousDetail }}</small>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="1" class="d-flex align-items-center">
              <span v-if="processedItem.quantity > 1" class="text-nowrap">
                Qty: {{ processedItem.quantity }}
              </span>
            </b-col>
            <b-col cols="2" class="d-flex align-items-center">
              <b-dropdown
                class="status-dropdown"
                menu-class="dropdown-menu--status"
                toggle-class="btn--badge-pill"
                :disabled="isItemStatusDisabled"
              >
                <template v-slot:button-content v-if="processedItem.outlet">
                  @ {{ processedItem.outlet.abbreviation }}
                </template>
                <b-dropdown-item-button
                  v-for="outlet in selectableOutlets"
                  :key="outlet.id"
                  @click="onOutletChange(outlet.id)"
                  :active="processedItem.outlet && processedItem.outlet.id === outlet.id"
                >
                  <span class="ml-2">{{ outlet.name }}</span>
                </b-dropdown-item-button>
              </b-dropdown>
            </b-col>
            <b-col cols="3" class="d-flex align-items-center">
              <b-dropdown
                :id="'dropdown-' + item.id"
                class="status-dropdown"
                menu-class="dropdown-menu--status"
                toggle-class="btn--badge-pill"
                :variant="
                  getStatusVariant(item.quantity === -1 ? 'refunded' : item.dispense_status_id)
                "
                :disabled="isItemStatusDisabled"
              >
                <template v-slot:button-content>
                  {{ processedItem.dispenseStatusDisplay }}
                </template>
                <div v-if="nextDispenseStatus" class="dropdown-group">
                  <div class="dropdown-group__title">Move status to next</div>
                  <b-dropdown-item-button @click="onStatusChange(nextDispenseStatus.slug)">
                    <span class="dot dot--sm dot--secondary mr-2" />
                    <span>{{ nextDispenseStatus.display_name }}</span>
                  </b-dropdown-item-button>
                  <b-dropdown-divider></b-dropdown-divider>
                </div>
                <b-dropdown-item-button
                  v-for="status in selectableItemStatuses"
                  :key="status.slug"
                  :variant="getStatusVariant(item.dispense_status_id)"
                  @click="onStatusChange(status.slug)"
                >
                  <span :class="getStatusVariant(status.slug)" class="dot dot--sm mr-2" />
                  <span>{{ status.display_name }}</span>
                </b-dropdown-item-button>
              </b-dropdown>
            </b-col>
            </b-col>
          </b-row>
          <div class="item-action-buttons">
            <b-button
              variant="icon-text-transparent"
              @click="openActivityHistory"
            >
              <span class="icon">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.853 8.658l2.219 2.219c.158.158.237.357.237.597 0 .239-.08.438-.237.597-.159.158-.358.237-.597.237-.24 0-.438-.08-.597-.237l-2.48-2.48a.853.853 0 01-.19-.282.886.886 0 01-.063-.312V5.999c0-.24.082-.442.247-.607a.822.822 0 01.606-.247c.24 0 .442.082.606.247.165.165.247.367.247.607v2.66zm.847-5.11a.74.74 0 00-.303-.737.74.74 0 01-.304-.738c0-.289.101-.535.303-.737a.989.989 0 01.738-.304c.289 0 .535.101.737.304.202.202.303.448.303.737 0 .29-.1.535-.303.738a.989.989 0 01-.737.303.989.989 0 01-.738-.303zm0 12.375a.74.74 0 00-.303-.738.74.74 0 01-.304-.737c0-.29.101-.536.303-.738a.989.989 0 01.738-.303c.289 0 .535.1.737.303.202.202.303.449.303.738s-.1.535-.303.737a.989.989 0 01-.737.304.989.989 0 01-.738-.304zm3-9.75a.74.74 0 00-.303-.737.74.74 0 01-.304-.738c0-.289.101-.535.303-.737a.989.989 0 01.738-.304c.289 0 .535.101.737.304.202.202.303.448.303.737 0 .29-.1.535-.303.738a.989.989 0 01-.737.303.989.989 0 01-.738-.303zm0 7.125a.74.74 0 00-.303-.738.74.74 0 01-.304-.737c0-.29.101-.536.303-.738a.989.989 0 01.738-.303c.289 0 .535.1.737.303.202.202.303.449.303.738s-.1.535-.303.737a.989.989 0 01-.737.304.989.989 0 01-.738-.304zm1.125-3.562a.74.74 0 00-.303-.738.74.74 0 01-.304-.737c0-.29.101-.536.304-.738a.989.989 0 01.737-.303c.29 0 .535.1.738.303.202.202.303.449.303.738s-.101.535-.303.737a.989.989 0 01-.738.304.989.989 0 01-.737-.304zM3.372 3.898c1.308-1.426 2.916-2.24 4.825-2.443a.69.69 0 01.567.203.77.77 0 01.236.604.84.84 0 01-.215.597.872.872 0 01-.546.307c-1.459.19-2.677.833-3.655 1.93-.978 1.096-1.467 2.397-1.467 3.902 0 1.515.489 2.818 1.467 3.91.978 1.092 2.197 1.733 3.655 1.923a.872.872 0 01.546.307.84.84 0 01.215.597.77.77 0 01-.236.604.69.69 0 01-.567.203c-1.918-.203-3.529-1.017-4.832-2.443C2.062 12.673 1.41 10.973 1.41 8.999c0-1.975.654-3.675 1.962-5.1z" fill="currentColor"/>
                </svg>
              </span>
              <span class="text">Activity History</span>
            </b-button>
            <b-button
              variant="icon-text-transparent"
              @click="openCommentsModal(item)"
            >
              <span class="icon" :class="{ active: item.notes && item.notes.length > 0 }">
                <i class="di-comment-18" />
              </span>
              <span class="text">
                {{ item.notes && item.notes.length }}
                {{ (item.notes && item.notes.length) > 2 ? 'Notes' : 'Note' }}
              </span>
            </b-button>
          </div>
          <b-brow>
            <b-col style="margin-left: 31px" cols="12">
              <small class="text-muted" v-if="hoyaStatusText">
                <strong>Hoya Order:</strong> <span v-html="hoyaStatusText" />
              </small>
            </b-col>
          </b-brow>
          <b-brow>
            <b-col style="margin-left: 31px" cols="12">
              <small class="text-muted" v-if="hoyaBarkodText">
                <strong>Hoya Barcode:</strong> <span v-html="hoyaBarkodText" />
              </small>
            </b-col>
          </b-brow>
          <b-brow>
            <b-col style="margin-left: 31px" cols="12">
              <small class="text-muted" v-if="shamirStatusText">
                <strong>Shamir Order:</strong> <span v-html="shamirStatusText" />
              </small>
            </b-col>
          </b-brow>
          <b-brow>
            <b-col style="margin-left: 31px" cols="12">
              <small class="text-muted" v-if="plasticplusStatusText">
                <strong>PlasticPlus Order:</strong> <span v-html="plasticplusStatusText" />
              </small>
            </b-col>
          </b-brow>
        </b-container>
      </div>
      <b-collapse :visible="visible" v-if="hasMoreDetails">
        <div class="rd-deep-2" v-if="loading" style="display: flex; justify-content: center">
          <b-spinner />
        </div>

        <div class="rd-deep-2" v-if="!loading">
          <b-container fluid>
            <b-row>
              <b-col cols="4" v-if="frame">
                <h6 class="text-uppercase">Frame</h6>
                <div class="part-selection">
                  <div
                    class="part-selection__dot part-selection__dot--black"
                    v-if="frame.sizeId"
                  >
                    {{ frame.sizeId === 'extra-small' ? 'XS' : frame.sizeId.charAt(0) }}
                  </div>
                  <div
                    v-if="frame.sizeId != 'Non-Dresden'"
                    class="part-selection__dot"
                    :style="{
                      borderColor: this._.get(frame, 'color.hex_code') || '#fff',
                      backgroundColor: this._.get(frame, 'color.hex_code') || '#fff',
                    }"
                  ></div>
                  <div class="part-selection__label" v-if="frame.sizeId !== 'Non-Dresden'">
                    {{ this._.get(frame, 'color.name') }}
                  </div>
                  <div class="part-selection__label" v-else>Non-Dresden</div>
                </div>
              </b-col>

              <b-col cols="4">
                <b-col cols="12" v-if="hasArm">
                  <h6 class="text-uppercase">Right Arm</h6>
                  <div class="part-selection">
                    <div
                      class="part-selection__dot part-selection__dot--black"
                      v-if="rightArm.sizeId"
                    >
                      {{ rightArm.sizeId === 'extra-small' ? 'XS' : rightArm.sizeId.charAt(0) }}
                    </div>
                    <div
                      v-if="(frame && frame.sizeId !== 'Non-Dresden') || !frame"
                      class="part-selection__dot"
                      :class="
                        this._.get(rightArm, 'color.name')
                          ? rightArm.color.name.toLowerCase() === 'white'
                            ? 'part-selection__dot--white'
                            : ''
                          : ''
                      "
                      :style="{
                        borderColor: this._.get(rightArm, 'color.hex_code') || '#fff',
                        backgroundColor: this._.get(rightArm, 'color.hex_code') || '#fff',
                      }"
                    ></div>
                    <div
                      class="part-selection__label"
                      v-if="(frame && frame.sizeId !== 'Non-Dresden') || !frame"
                    >
                      {{ this._.get(rightArm, 'color.name') }}
                    </div>
                    <div class="part-selection__label" v-else>Non-Dresden</div>
                  </div>
                </b-col>

                <b-col cols="12" v-if="hasArm" style="margin-top: 10px">
                  <h6 class="text-uppercase">Left Arm</h6>
                  <div class="part-selection">
                    <div
                      class="part-selection__dot part-selection__dot--black"
                      v-if="leftArm.sizeId"
                    >
                      {{ leftArm.sizeId === 'extra-small' ? 'XS' : leftArm.sizeId.charAt(0) }}
                    </div>
                    <div
                      v-if="(frame && frame.sizeId !== 'Non-Dresden') || !frame"
                      class="part-selection__dot"
                      :class="
                        this._.get(leftArm, 'color.name')
                          ? leftArm.color.name.toLowerCase() === 'white'
                            ? 'part-selection__dot--white'
                            : ''
                          : ''
                      "
                      :style="{
                        borderColor: this._.get(leftArm, 'color.hex_code') || '#fff',
                        backgroundColor: this._.get(leftArm, 'color.hex_code') || '#fff',
                      }"
                    ></div>
                    <div
                      class="part-selection__label"
                      v-if="(frame && frame.sizeId !== 'Non-Dresden') || !frame"
                    >
                      {{ this._.get(leftArm, 'color.name') }}
                    </div>
                    <div class="part-selection__label" v-else>Non-Dresden</div>
                  </div>
                </b-col>
              </b-col>

              <b-col cols="4" v-if="shape">
                <h6 class="text-uppercase">Shape</h6>
                <div class="shape-container text-center" v-if="shape">
                  <img :src="shape.image" :alt="shape.text" class="shape-image" />
                  <span class="d-block mt-2">{{ shape.text }}</span>
                </div>
              </b-col>
            </b-row>

            <b-row v-if="isExistingDresden" style="flex-direction: column">
              <b-col>
                <h6 class="text-uppercase">Options</h6>
                <span>LENSES ONLY</span>
              </b-col>
            </b-row>

            <b-row v-if="dredenGoPurpose && dresdenGoPower" style="flex-direction: column">
              <b-col>
                <h6 class="text-uppercase">DresdenGo Options</h6>
                <p>Purpose: {{ dredenGoPurpose.toUpperCase() }}</p>
                <p>Power: {{ dresdenGoPower.toUpperCase() }}</p>
              </b-col>
            </b-row>

            <!-- Dresden Reading Section -->
            <b-row v-if="hasDresdenReading" class="mt-3">
              <b-col cols="12">
                <h6 class="text-uppercase">Dresden Reading Glasses</h6>
              </b-col>
              <b-col cols="4" class="mt-2" v-if="dresdenReadingPrescription">
                <h6 class="text-uppercase">Prescription</h6>
                <p>
                  <PrescriptionDetail
                    :prescription="dresdenReadingPrescription"
                    :lensesToPick="dresdenReadingLensesToPick"
                  />
                </p>
              </b-col>
              <b-col cols="4" class="mt-2" v-if="dresdenReadingPd">
                <h6 class="text-uppercase">Pupil Distance</h6>
                <p>
                  <PupilDistanceDetail :pd="dresdenReadingPd" type="width" />
                </p>
              </b-col>
              <b-col cols="4" class="mt-2" v-if="dresdenReadingPd && hasDresdenReadingPdHeight">
                <h6 class="text-uppercase">Pupil Height</h6>
                <p>
                  <PupilDistanceDetail :pd="dresdenReadingPd" type="height" />
                </p>
              </b-col>
              <b-col cols="12" class="mt-2" v-if="dresdenReadingLens">
                <h6 class="text-uppercase">Lenses</h6>
                <div>
                  <span>{{ dresdenReadingLens.name }}</span>
                </div>
              </b-col>
              <b-col cols="12" class="mt-2" v-if="dresdenReadingLensCoating">
                <h6 class="text-uppercase">Coating</h6>
                <div>
                  <span>{{ dresdenReadingLensCoating }}</span>
                </div>
              </b-col>
            </b-row>

            <b-row v-show="isPrescriptionRequired">
              <b-col cols="4" class="mt-5" v-if="prescription">
                <h6 class="text-uppercase">Prescription</h6>
                <p v-if="prescription.detail">
                  <PrescriptionDetail
                    :prescription="prescription.detail"
                    :lensesToPick="item.additional_info.lensesToPick"
                  />
                </p>

                <div v-if="prescriptionNote">
                  <h6 class="text-uppercase">Prescription Note</h6>
                  <p>{{ prescriptionNote }}</p>
                </div>
              </b-col>
              <b-col cols="8" class="mt-5">
                <b-row>
                  <b-col cols="5" v-if="pd">
                    <h6 class="text-uppercase">
                      {{ isMultifocal ? 'Width' : 'Pupil Distance' }}
                    </h6>
                    <p>
                      <PupilDistanceDetail :pd="pd" type="width" :sourceMessage="sourceMessage" />
                    </p>
                  </b-col>
                  <b-col cols="5" v-if="pd && hasPdHeight">
                    <h6 class="text-uppercase">
                      {{ isMultifocal ? 'Height' : 'Pupil Height' }}
                    </h6>
                    <p>
                      <PupilDistanceDetail :pd="pd" type="height" :sourceMessage="sourceMessage" />
                    </p>
                  </b-col>
                  <b-col cols="2" v-if="prescriptionTypeId">
                    <h6 class="text-uppercase">Purpose</h6>
                    <span class="text-capitalize">
                      {{ prescriptionTypeId }}
                    </span>
                  </b-col>
                  <div v-if="presenterNote">
                    <p class="warning mr-2 mt-3">{{ presenterNote }}</p>
                  </div>
                </b-row>
              </b-col>
            </b-row>
            <PrismDisplay v-if="isPrescriptionRequired && prescription" :prescription="prescription.detail" class="mt-2" />
            <b-row v-show="isPrescriptionRequired" class="mt-5">
              <b-col cols="4" v-if="lenses">
                <h6 class="text-uppercase">Lenses</h6>
                <div>
                  <span>{{ lenses.name }}</span>
                  <div v-if="isLensUpgraded && lensUpgradeReason" class="mt-1">
                    <div class="upgrade-badge-container" style="position: relative; display: inline-block;">
                      <b-badge
                        variant="warning"
                        @mouseenter="showDetailTooltip = true"
                        @mouseleave="showDetailTooltip = false"
                        style="cursor: help;"
                      >
                        UPGRADED
                      </b-badge>
                      <div
                        v-if="showDetailTooltip"
                        class="custom-tooltip"
                        style="
                          position: absolute;
                          bottom: 100%;
                          left: 50%;
                          transform: translateX(-50%);
                          background: #333;
                          color: white;
                          padding: 8px 12px;
                          border-radius: 4px;
                          font-size: 12px;
                          z-index: 1000;
                          margin-bottom: 5px;
                          box-shadow: 0 2px 8px rgba(0,0,0,0.3);
                          width: 300px;
                          white-space: normal;
                          word-wrap: break-word;
                          text-align: center;
                        "
                      >
                        {{ lensUpgradeReason }}
                        <div style="
                          position: absolute;
                          top: 100%;
                          left: 50%;
                          transform: translateX(-50%);
                          border: 5px solid transparent;
                          border-top-color: #333;
                        "></div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div
                    class="lenses-to-pick-box"
                    v-if="isSingleVision && item.additional_info.lensesToPick"
                  >
                    <div>
                      <b>R</b>
                      <span>{{ lensesToPickRx(item.additional_info.lensesToPick.right) }}</span>
                    </div>
                    <div>
                      <b>L</b>
                      <span>{{ lensesToPickRx(item.additional_info.lensesToPick.left) }}</span>
                    </div>
                    <div v-if="item.additional_info.lensesToPick.add">
                      <b>{{ item.additional_info.lensesToPick.add }}</b>
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col cols="8">
                <b-row>
                  <b-col cols="4" v-if="lensCoating">
                    <h6 class="text-uppercase">Coating(s)</h6>
                    <div>
                      <span>{{ lensCoating }}</span>
                    </div>
                    <div v-if="newLensCoating">
                      <hr />
                      <span>{{ newLensCoating }}</span>
                    </div>
                  </b-col>
                  <b-col cols="4" v-if="lensColor">
                    <h6 class="text-uppercase">Colour</h6>
                    <div>
                      <span>{{ lensColor }}</span>
                    </div>
                  </b-col>
                  <b-col cols="4" v-if="selectedLensMod">
                    <h6 class="text-uppercase">Lens Style</h6>
                    <div>
                      <span>{{ selectedLensMod.name }} ({{ selectedLensMod.code }})</span>
                    </div>
                  </b-col>
                  <b-col cols="4" v-if="selectedLensModCorridor">
                    <h6 class="text-uppercase">Corridor</h6>
                    <div>
                      <span>{{ selectedLensModCorridor.name }} ({{ selectedLensModCorridor.code }})</span>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <PrismDisplay
              v-if="item.additional_info.lensesToPick"
              :prescription="{ prism_string: lensesToPickPrism }"
              class="mt-2"
            />
            <div v-if="isContactLens">
              <div>
                <span>Contact Prescription - {{ contactLensType }}</span>
                <br />
                <div class="lenses-to-pick-box" v-if="contactLensType !== 'Bundle'">
                  <div
                    v-for="(key, contactLensPrescriptionData) in contactLensPrescription"
                    v-bind:key="key"
                  >
                    <div>
                      <b>{{ contactLensPrescriptionData.toUpperCase().replace('MF', 'ADD') }}</b>
                      <span>{{ key }}</span>
                    </div>
                  </div>
                </div>

                <b-row class="mt-3" v-if="contactLensType == 'Bundle'">
                  <b-col cols="6">
                    <div class="lenses-to-pick-box">
                      <p>Right</p>
                      <div
                        v-for="(key, contactLensPrescriptionData) in contactLensPrescriptionR"
                        v-bind:key="key"
                      >
                        <div>
                          <b>{{
                            contactLensPrescriptionData.toUpperCase().replace('MF', 'ADD')
                          }}</b>
                          <span>{{ key }}</span>
                        </div>
                      </div>
                    </div>
                  </b-col>

                  <b-col cols="6">
                    <div class="lenses-to-pick-box">
                      <p>Left</p>
                      <div
                        v-for="(key, contactLensPrescriptionData) in contactLensPrescriptionL"
                        v-bind:key="key"
                      >
                        <div>
                          <b>{{
                            contactLensPrescriptionData.toUpperCase().replace('MF', 'ADD')
                          }}</b>
                          <span>{{ key }}</span>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <div v-if="hasContactLensPrescriptionFile">
                  Prescription File
                  <div>
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      @click="handleViewFileContactLensPrescription"
                    >
                      <svgicon name="paperclip" />
                      <span class="ml-1">View File</span>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="contactLensRxDisplay || isContactLensItem" class="mt-3">
              <h6 class="text-uppercase">Contact Lens Prescription</h6>
              <b-row v-if="contactLensRxDisplay">
                <b-col v-if="contactLensRxDisplay.prescriptionR" cols="6">
                  <div class="lenses-to-pick-box">
                    <p class="font-weight-bold mb-1">Right</p>
                    <div
                      v-for="(value, label) in contactLensRxDisplay.prescriptionR"
                      :key="'rx-r-' + label"
                    >
                      <b>{{ label }}:</b> {{ value }}
                    </div>
                  </div>
                </b-col>
                <b-col v-if="contactLensRxDisplay.prescriptionL" cols="6">
                  <div class="lenses-to-pick-box">
                    <p class="font-weight-bold mb-1">Left</p>
                    <div
                      v-for="(value, label) in contactLensRxDisplay.prescriptionL"
                      :key="'rx-l-' + label"
                    >
                      <b>{{ label }}:</b> {{ value }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <p v-else class="text-muted mt-2 mb-0">No contact lens prescription on this order.</p>
            </div>
            <div v-if="isHardCase && (hardCaseTopColor || hardCaseBottomColor)" class="mt-3">
              <h6 class="text-uppercase">Hard Case Colors</h6>
              <div class="lenses-to-pick-box">
                <div v-if="hardCaseTopColor">
                  <b>Lid Color:</b>
                  <span class="ml-2">{{ hardCaseTopColor }}</span>
                </div>
                <div v-if="hardCaseBottomColor">
                  <b>Base Color:</b>
                  <span class="ml-2">{{ hardCaseBottomColor }}</span>
                </div>
              </div>
            </div>
          </b-container>
        </div>
        <div v-if="item.next_scheduled_date" class="rd-deep-2-actions">
          <div class="buttons-wrapper">
            <b-row>
              <b-col class="mt-auto mb-auto">
                <p class="text-left mb-0">
                  Next lenses replenishment is &nbsp;{{
                    item.next_scheduled_date | moment('from', 'now')
                  }}
                </p>
              </b-col>
              <b-col> </b-col>
            </b-row>
          </div>
        </div>
        <div v-if="prescriptionWarningMessage" class="prescription-warning mt-3">
          <b-alert show variant="warning">{{ prescriptionWarningMessage }}</b-alert>
        </div>
      </b-collapse>
    </div>
    <input
      :id="'item-' + processedItem.id"
      type="checkbox"
      class="custom-control-input"
      :value="processedItem.id"
      @change="handleSelectItemChange"
      :checked="selectedOrderItemIds.includes(processedItem.id)"
      :disabled="isItemStatusDisabled"
    />
    <label :for="'item-' + processedItem.id" class="custom-control-label order-item-label" :class="{ disabled: isItemStatusDisabled }" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import apiOrders from '@/api/orders';
import apiNotes from '@/api/notes';
import PrismDisplay from '@/components/PrismDisplay.vue';
import PupilDistanceDetail from './PupilDistanceDetail.vue';
import PrescriptionDetail from './PrescriptionDetail.vue';
import { escapeHtml } from '@/support/sanitize';
import { requiresPrescription } from '@/support/product';

const FRAME_PART_TYPE_KEYS = {
  set: ['frame-set'],
  front: ['extra-frame', 'le-extra-frame'],
  arms: ['extra-temples', 'le-extra-temples'],
};

const GLASSES_TYPE_KEYS_SET = new Set([
  'glasses',
  'lenses-only',
  'single-vision',
  'multifocal',
  'bifocal',
  'trifocal',
  'desk',
  'dresdengo',
  'dg-reading-glass',
]);

function resolveItemFramePartType(item) {
  let type = item?.region_product?.product?.type;
  while (type) {
    if (GLASSES_TYPE_KEYS_SET.has(type.key)) return null;
    if (FRAME_PART_TYPE_KEYS.set.includes(type.key)) return 'set';
    if (FRAME_PART_TYPE_KEYS.front.includes(type.key)) return 'front';
    if (FRAME_PART_TYPE_KEYS.arms.includes(type.key)) return 'arms';
    type = type.parent_type;
  }
  const attr = item?.region_product?.product?.attribute;
  if (attr) {
    if (attr.arm_size || attr.arm_colour_id) return 'arms';
    if (attr.frame_size || attr.frame_colour_id) return 'front';
  }
  const name = (item?.region_product?.product?.name || '').trim().toLowerCase();
  if (/warranty\s*claim\s*\/\s*frame\s*set/.test(name)) return 'set';
  if (/warranty\s*claim\s*\/\s*arms?\b/.test(name)) return 'arms';
  if (/warranty\s*claim\s*\/\s*frame\b/.test(name)) return 'front';
  if (/^frame\s*parts\s*\/\s*arms?\b/.test(name)) return 'arms';
  if (/^frame\s*parts\s*\/\s*frame\b/.test(name)) return 'front';
  return null;
}

export default {
  name: 'OrderItemListDetail',
  components: {
    PrescriptionDetail,
    PupilDistanceDetail,
    PrismDisplay,
  },
  props: {
    order: Object,
    item: Object,
    invoice: String,
    orderStatus: String,
  },
  data() {
    return {
      visible: false,
      showTooltip: false,
      showDetailTooltip: false,
      monthNames: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      statusDropdownOpen: false,
      loading: false,
      frameShapes: [
        {
          value: 'original',
          text: 'Original',
          image: 'https://w.dresden.vision/images/icons/shape_classic.png',
        },
        {
          value: 'capote',
          text: 'Capote',
          image: 'https://w.dresden.vision/images/icons/shape_round.png',
        },
        {
          value: 'non-dresden',
          text: 'Non-Dresden',
          image: 'https://w.dresden.vision/images/non-dresden.png',
        },
      ],
    };
  },
  mounted() {
    // A reload swaps the whole details panel for the v-wait spinner, so items are re-created and
    // anything that has to stay open across it has to be read back here.
    const expandItemIds = [].concat(this.$store.state.expandItemId || []);
    if (expandItemIds.includes(this.item.id)) {
      this.visible = true;
      this.$nextTick(() => this.$store.commit('SET_EXPAND_ITEM_ID', null));
    }

    const dropdownId = `dropdown-${this.item.id}`;
    this.$root.$on(`bv::dropdown::show`, bvEvent => {
      if (bvEvent.componentId === dropdownId) {
        this.statusDropdownOpen = true;
      }
    });

    this.$root.$on(`bv::dropdown::hide`, bvEvent => {
      if (bvEvent.componentId === dropdownId) {
        this.statusDropdownOpen = false;
      }
    });
  },
  computed: {
    ...mapState({
      orderItemStatuses: state => state.orderItemStatuses,
      currentUser: state => state.auth.user,
      selectedJob: state => state.jobsModule.selectedJobData,
    }),
    ...mapGetters(['selectableItemStatuses', 'selectableOutlets', 'selectedOrderItemIds']),
    processedItem() {
      const item = { ...this.item };
      let dispenseStatus = this.item.dispense_status_id;
      if (this.item.quantity === -1) {
        dispenseStatus = 'refunded';
      }
      if (this.order.dispense_status_id === 'voided') {
        dispenseStatus = 'voided';
      }
      item.dispenseStatusDisplay = this.getStatusDisplayName(
        dispenseStatus,
        this.orderItemStatuses,
      );
      return item;
    },
    hoyaStatusText() {
      const hoyaStatus = this.item?.hoya_status;
      if (!hoyaStatus || hoyaStatus.length === 0) return '';

      // DP-4629: Hoya's date is the shipping date, not the arrival date at the store.
      // Before dispatch it is when Hoya expects to ship; after dispatch it is when they did.
      // DP-4804: showing both dates before dispatch was raised as a bug and the fix was
      // withdrawn on 2026-09-10 — Hakim confirmed with Hoya that the stores want the
      // forecast while a lens is in manufacture, even though Hoya rewrites it on dispatch.
      let details = '';
      const hasHoyaDate =
        hoyaStatus.orderDeliveryDate && Number(hoyaStatus.orderStatus) > 0;

      if (hasHoyaDate) {
        // Fallback keeps the label correct if io-go ships ahead of the api-v4 release.
        const dateLabel =
          hoyaStatus.date_label ||
          (Number(hoyaStatus.orderStatus) === 9
            ? 'Hoya Shipped Date'
            : 'Expected Hoya Shipping Date');
        details += `<br><strong>${escapeHtml(dateLabel)}:</strong> ${this.formatHoyaDate(
          hoyaStatus.orderDeliveryDate,
        )}`;
      }

      // DP-4629: only once it has actually shipped — "Shipped From" on an order still
      // in manufacture reads as though it were already on its way (Oguz, 2026-08-31).
      // Diverges from AC 8, which asked to show Hoya Sydney on open orders too.
      // The code is appended only when Hoya sent one; on production they do not send
      // it yet, so shipped orders there show the name alone.
      const isShipped = hoyaStatus.is_shipped ?? Number(hoyaStatus.orderStatus) === 9;

      if (isShipped && hoyaStatus.shipped_from) {
        const shippedFrom = hoyaStatus.shipped_from_code
          ? `${hoyaStatus.shipped_from} (${hoyaStatus.shipped_from_code})`
          : hoyaStatus.shipped_from;
        details += `<br><strong>Shipped From:</strong> ${escapeHtml(shippedFrom)}`;
      }

      if (hasHoyaDate && hoyaStatus.estimated_delivery_date) {
        details += `<br><strong>Estimated Delivery Date:</strong> ${this.formatHoyaDate(
          hoyaStatus.estimated_delivery_date,
        )}`;
      }

      return `${escapeHtml(hoyaStatus.orderStatusMessage)} (${escapeHtml(hoyaStatus.orderId)}) ${details}`;
    },
    hoyaBarkodText() {
      if (!this.item?.hoya_status || this.item?.hoya_status.length === 0 || !this.item?.hoya_status.receiveNo) return '';
      return `HO${escapeHtml(this.item.hoya_status.receiveNo)}`;
    },
    shamirStatusText() {
      const { shamir_status: statuses } = this.item || {};
      if (!statuses || statuses.length === 0) return '';

      const shamirStatus = statuses[0];
      const { statusName, updated_at, estimatedShippingDate, tracking } = shamirStatus;

      const orderDate = new Date(updated_at);
      let orderDateText = `<br><strong>Updated Date:</strong> ${orderDate.getDate()} ${
        this.monthNames[orderDate.getMonth()]
      } ${orderDate.getFullYear()}`;

      if (estimatedShippingDate) {
        const estimatedDate = new Date(estimatedShippingDate);
        orderDateText += ` <br><strong>Expected Delivery Date:</strong> ${estimatedDate.getDate()} ${
          this.monthNames[estimatedDate.getMonth()]
        } ${estimatedDate.getFullYear()}`;
      }

      let trackingText = '';
      if (tracking) {
        const safeLink = /^https?:\/\//i.test(String(tracking.trackingLink || '').trim())
          ? escapeHtml(tracking.trackingLink) : '#';
        trackingText = `<br><a href="${safeLink}" target="_blank"><strong>Tracking:</strong> ${escapeHtml(tracking.courierName)} ${escapeHtml(tracking.trackingNo)}</a>`;
      }

      return `${escapeHtml(statusName)} ${orderDateText}${trackingText}`;
    },
    plasticplusStatusText() {
      const plasticplusStatus = this.item?.plasticplus_status;
      if (!plasticplusStatus) return '';

      const { Status, StatusDate, Type, RxNumber, Patient, TrayNumber, PoNumber } = plasticplusStatus;

      let statusText = escapeHtml(Status) || '';
      let detailsText = '';

      if (Type) {
        detailsText += `<br><strong>Type:</strong> ${escapeHtml(Type)}`;
      }

      if (StatusDate) {
        detailsText += `<br><strong>Status Date:</strong> ${escapeHtml(StatusDate)}`;
      }

      if (PoNumber) {
        detailsText += `<br><strong>PO Number:</strong> ${escapeHtml(PoNumber)}`;
      }

      return `${statusText}${detailsText}`;
    },
    checked() {
      return this.$store.getters.selectedOrderItemIds.findIndex(id => id === this.item.id) > -1;
    },
    nextDispenseStatus() {
      const index = this.selectableItemStatuses.findIndex(
        status => status.slug === this.item.dispense_status_id,
      );
      return index > -1 ? this.selectableItemStatuses[index + 1] : null;
    },
    isItemStatusDisabled() {
      // Disable status changes if order is cancelled, voided, or refunded
      if (
        this.orderStatus === 'cancelled' ||
        this.orderStatus === 'voided' ||
        this.orderStatus === 'refunded-transaction' ||
        this.orderStatus === 'refunded'
      ) {
        return true;
      }
      // Also disable if this specific item is refunded (quantity === -1)
      if (this.item.quantity === -1) {
        return true;
      }
      return false;
    },
    productName() {
      const productName = this._.get(this.item, 'region_product.name', '');
      const name = this._.get(productName.split('/'), '0').trim();
      return this._.get(this.item, 'is_kids', false) ? `Kids ${name}` : name;
    },
    productOptions() {
      const productName = this._.get(this.item, 'region_product.name', '');
      const segments = productName.split('/');
      return segments.slice(1).join('/');
    },
    framePartType() {
      return resolveItemFramePartType(this.item);
    },
    frame() {
      if (this.framePartType === 'arms') return null;
      const frame = this._.get(this.item, 'additional_info.data.customize.component.Frame');
      if (!frame) return null;
      if (frame.sizeId != null && typeof frame.sizeId !== 'string') return null;
      return frame;
    },
    shape() {
      if (!this.frame) return null;
      let shapeName = this.frame.shape;
      if (shapeName == null) {
        shapeName = this.frame.sizeId.toLowerCase().includes('round') ? 'capote' : 'original';
      }
      if (!shapeName) return null;
      const sizeId = this.frame.sizeId;

      if (sizeId == 'Non-Dresden') {
        shapeName = 'non-dresden';
      }

      const getShape = this.frameShapes.find(
        shape => shape.value.toLowerCase() === shapeName.toLowerCase(),
      );
      return getShape;
    },
    leftArm() {
      if (this.framePartType === 'front') return null;
      return this._.get(this.item, 'additional_info.data.customize.component.Temple Left');
    },
    rightArm() {
      if (this.framePartType === 'front') return null;
      return this._.get(this.item, 'additional_info.data.customize.component.Temple Right');
    },

    isContactLens() {
      const getType = this._.get(this.item, 'additional_info.data.productType');
      if (getType && getType === 'contact-lens') {
        return true;
      }
      return false;
    },
    isHardCase() {
      const hardCaseBottomColor = this._.get(this.item, 'additional_info.data.customize.component["Hard Case Bottom"].color');
      return hardCaseBottomColor;
    },
    hardCaseTopColor() {
      const topColor = this._.get(this.item, 'additional_info.data.customize.component["Hard Case Top"].color');
      if (topColor) {
        return topColor.name;
      }
      // Fallback to hardCaseTopColor in additional_info.data
      return this._.get(this.item, 'additional_info.data.hardCaseTopColor');
    },
    hardCaseBottomColor() {
      const bottomColor = this._.get(this.item, 'additional_info.data.customize.component["Hard Case Bottom"].color');
      if (bottomColor) {
        return bottomColor.name;
      }
      // Fallback to hardCaseBottomColor in additional_info.data
      return this._.get(this.item, 'additional_info.data.hardCaseBottomColor');
    },
    contactLensType() {
      return this._.get(this.item, 'additional_info.data.contactLensType');
    },
    hasContactLensPrescriptionFile() {
      return this._.get(this.item, 'additional_info.data.prescriptionImage');
    },
    contactLensPrescription() {
      const prescription = this._.get(this.item, 'additional_info.data.prescription');

      const result = {
        bc: prescription.bc,
        dia: prescription.dia,
        sph: prescription.sph,
        cyl: prescription.cyl,
        axis: prescription.axis,
        add: prescription.add,
        mf: prescription.mf,
        addtype: prescription.addtype,
      };

      // Remove properties with undefined values
      Object.keys(result).forEach(key => result[key] === undefined && delete result[key]);

      return result;
    },
    contactLensPrescriptionR() {
      const prescription = this._.get(this.item, 'additional_info.data.prescriptionR');

      const result = {
        bc: prescription.bc,
        dia: prescription.dia,
        sph: prescription.sph,
        cyl: prescription.cyl,
        axis: prescription.axis,
        add: prescription.add,
        mf: prescription.mf,
        addtype: prescription.addtype,
      };

      // Remove properties with undefined values
      Object.keys(result).forEach(key => result[key] === undefined && delete result[key]);

      return result;
    },
    contactLensPrescriptionL() {
      const prescription = this._.get(this.item, 'additional_info.data.prescriptionL');

      const result = {
        bc: prescription.bc,
        dia: prescription.dia,
        sph: prescription.sph,
        cyl: prescription.cyl,
        axis: prescription.axis,
        add: prescription.add,
        mf: prescription.mf,
        addtype: prescription.addtype,
      };

      // Remove properties with undefined values
      Object.keys(result).forEach(key => result[key] === undefined && delete result[key]);

      return result;
    },
    contactLensRxDisplay() {
      const rx = this._.get(this.item, 'contact_lens_rx_display');
      if (!rx) return null;
      if (!rx.prescriptionR && !rx.prescriptionL && !(rx.prescription && rx.prescription.length)) return null;
      return rx;
    },
    isContactLensItem() {
      return !!this._.get(this.item, 'is_contact_lens');
    },
    hasArm() {
      return this.leftArm || this.rightArm;
    },
    prescription() {
      return this._.get(this.item, 'additional_info.data.prescription');
    },
    lensesToPickPrism() {
      const lensesToPick = this._.get(this.item, 'additional_info.lensesToPick');
      const prismString = {
        near: { right: {}, left: {} },
        distance: { right: {}, left: {} },
      };
      if (!lensesToPick) return prismString;
      ['right', 'left'].forEach(side => {
        const value = lensesToPick[side];
        if (!value) return;
        value.split(/<br\s*\/?>/i).forEach(line => {
          const match = line.match(/(Near|Distance)\s+(Horizontal|Vertical)\s*:\s*(.+)/i);
          if (match) {
            const zone = match[1].toLowerCase();
            const axis = match[2].toLowerCase() === 'horizontal' ? 'horiz' : 'vert';
            prismString[zone][side][axis] = match[3].trim();
          }
        });
      });
      return prismString;
    },
    prescriptionNote() {
      return this._.get(this.prescription, 'detail.note');
    },
    prescriptionTypeId() {
      const typeId = this._.get(this.prescription, 'typeId');
      return typeId;
    },
    historicalDataPurpose() {
      const typeId = this._.get(
        this.item,
        'additional_info.data.historical_data.prescription.typeId',
      );
      return typeId;
    },
    dredenGoPurpose() {
      const typeId = this._.get(
        this.item,
        'additional_info.data.historical_data.woocommerce.Lens.attributes.attribute_pa_treatment',
      );
      return typeId;
    },
    dresdenGoPower() {
      const typeId = this._.get(
        this.item,
        'additional_info.data.historical_data.woocommerce.Lens.attributes.attribute_pa_power',
      );
      return typeId;
    },
    miscellaneousDetail() {
      return this._.get(
        this.item,
        'additional_info.data.historical_data.woocommerce.product_description',
      );
    },
    Ismiscellaneous() {
      const productType = this._.get(
        this.item,
        'additional_info.data.historical_data.woocommerce.product_type',
      );
      return productType === 'miscellaneous';
    },
    isPrescriptionEmail() {
      return this._.get(this.item, 'additional_info.data.historical_data.extra.prescription_email');
    },
    isSkipPD() {
      return this._.get(this.item, 'additional_info.data.historical_data.extra.skip_pd');
    },
    isHaveUsCallOptometrist() {
      return this._.get(
        this.item,
        'additional_info.data.historical_data.extra.have_us_call_optometrist',
      );
    },
    sourceMessage() {
      const sourceId = this._.get(this.item, 'additional_info.data.pd.detail.source_id');
      if (sourceId && this.$store.state.pdSources) {
        const selectedSource = this.$store.state.pdSources.find(
          source => source.slug === 'o-pm' && source.id === sourceId,
        );
        if (selectedSource) {
          return true;
        }
      }
      return false;
    },
    pd() {
      return (
        this._.get(this.item, 'additional_info.pdPresenter') ||
        this._.get(this.item, 'additional_info.data.pd')
      );
    },
    presenterNote() {
      return this._.get(this.item, 'additional_info.pdPresenter.data.height.error_message');
    },
    hasPdHeight() {
      return !!this._.get(this.pd, 'data.height.right');
    },
    lensAddonCombination() {
      return this._.get(this.item, 'additional_info.data.lens_addon_combination');
    },
    lenses() {
      return this._.get(this.lensAddonCombination, 'lenses');
    },
    productImage() {
      const path = this._.get(this.item, 'region_product.product.image_path');
      if (!path) {
        return null;
      }
      return this.getImageUrl(path);
    },
    hasMoreDetails() {
      return (
        this.frame ||
        this.hasArm ||
        this.prescription ||
        this.pd ||
        this.lenses ||
        this.isContactLens ||
        this.isContactLensItem ||
        this.isHardCase ||
        this.contactLensRxDisplay
      );
    },
    isMultifocal() {
      return this._.get(this.item, 'region_product.product.type.key').includes('multifocal');
    },
    isSingleVision() {
      return this._.get(this.item, 'region_product.product.type.key').includes('single-vision');
    },
    lensColor() {
      return this._.get(this.item, 'additional_info.lens_colour');
    },
    lensCoating() {
      return this._.get(this.lenses, 'coating');
    },
    newLensCoating() {
      return this._.get(this.item, 'additional_info.data.lens_addon_combination.coating.name');
    },
    isPrescriptionRequired() {
      return requiresPrescription(this.item.region_product);
    },

    isLensUpgraded() {
      return this.item.is_upgraded === 1 || this.item.is_upgraded === true ||
        !!this._.get(this.item, 'additional_info.data.product_upgrade_reason');
    },
    lensUpgradeReason() {
      return this.item.upgrade_reason ||
        this._.get(this.item, 'additional_info.data.product_upgrade_reason') || '';
    },
    selectedLensMod() {
      const saved = this._.get(this.item, 'additional_info.data.selected_lens_mod');
      if (saved) return saved;
      const mods = this._.get(this.lenses, 'lens_mods', []).filter(m => m.type === 'lens_style');
      return mods.find(m => m.is_default) || mods[0] || null;
    },
    selectedLensModCorridor() {
      const saved = this._.get(this.item, 'additional_info.data.selected_lens_mod_corridor');
      if (saved) return saved;
      const mods = this._.get(this.lenses, 'lens_mods', []).filter(m => m.type === 'lens_corridor');
      return mods.find(m => m.is_default) || mods[0] || null;
    },
    file() {
      if (typeof this.prescription !== 'undefined') {
        if (this.prescription.detail.files && this.prescription.detail.files.length) {
          // Return the latest file (last in array)
          return this.prescription.detail.files[this.prescription.detail.files.length - 1];
        }
      }
      return null;
    },
    orderItemID() {
      return this._.get(this.item, 'id');
    },
    orderItemPrice() {
      return this._.get(this.item, 'historical_unit_price');
    },
    isOctoposOrder() {
      return this._.get(this.order, 'is_octopos_order');
    },
    isExistingDresden() {
      return this._.get(
        this.item,
        'additional_info.data.customize.component.Frame.existingdresden',
      );
    },
    prescriptionWarningMessage() {
      const hasPrescription = !!this.prescription;
      const hasPD = !!this.pd;

      if (this.isPrescriptionEmail && !hasPrescription) {
        const email = this.getCustomerEmail();
        return `Prescription will be sent via email (from ${email}) as Zendesk ticket. If you have not received the prescription yet, please contact the customer.`;
      }
      if (this.isSkipPD && !hasPD) {
        return 'Customer clicked on "Skip PD" button. Please contact the customer to obtain PD information.';
      }
      if (this.isHaveUsCallOptometrist && (!hasPrescription || !hasPD)) {
        return 'Customer requested us to call their optometrist. Please call the optometrist to obtain the prescription details.';
      }
      return null;
    },
    // Dresden Reading Computed Properties
    hasDresdenReading() {
      return !!this._.get(this.item, 'DresdenGo_reading.prescription');
    },
    dresdenReadingPrescription() {
      return this._.get(this.item, 'DresdenGo_reading.prescription');
    },
    dresdenReadingPd() {
      const rawPd = this._.get(this.item, 'DresdenGo_reading.pd');
      if (!rawPd) return null;

      // Transform Dresden reading PD data to match PupilDistanceDetail component expectations
      return {
        data: {
          width: {
            right: rawPd.right_monocular_dist_pd,
            left: rawPd.left_monocular_dist_pd,
            binocular: rawPd.binocular_dist_pd,
          },
          height: {
            right: rawPd.right_height_multifocal,
            left: rawPd.left_height_multifocal,
          },
        },
      };
    },
    hasDresdenReadingPdHeight() {
      return !!this._.get(this.dresdenReadingPd, 'data.height.right');
    },
    dresdenReadingLens() {
      return this._.get(this.item, 'DresdenGo_reading.lens.lenses');
    },
    dresdenReadingLensCoating() {
      return this._.get(this.item, 'DresdenGo_reading.lens.coating.name');
    },
    dresdenReadingLensesToPick() {
      const prescription = this.dresdenReadingPrescription;
      if (!prescription) return null;

      const display = this._.get(prescription, 'standardised_prescription_display_array');
      if (display) {
        return {
          right: display.right,
          left: display.left,
          add: display.add || ''
        };
      }
      return null;
    },
  },
  methods: {
    // DP-4629: "26 August 2026". Date-only strings (YYYY-MM-DD) are parsed as local
    // time, not UTC, so the day does not slip backwards for non-Australian users.
    formatHoyaDate(value) {
      if (!value) return '';
      const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(String(value));
      const date = dateOnly ? new Date(`${value}T00:00:00`) : new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return `${date.getDate()} ${this.monthNames[date.getMonth()]} ${date.getFullYear()}`;
    },
    ...mapMutations({
      setSelectedPrescription: 'SET_SELECTED_PRESCRIPTION',
      setSelectedFile: 'SET_SELECTED_FILE',
    }),
    ...mapActions(['setSelectedOrderItems']),
    lensesToPickRx(value) {
      if (!value) return '';
      // Drop the prism block (shown below in PrismDisplay) and the leading R/L letter
      return value.split(/<br/i)[0].slice(1);
    },
    getTimeZone(order) {
      const region_id = this._.get(order, 'origin_outlet.region_id');
      let defaultTimeZone = 'Australia/Sydney';
      if (region_id === 5 || region_id === 13) {
        defaultTimeZone = 'America/Toronto';
      }
      return defaultTimeZone;
    },
    onStatusChange(id) {
      apiOrders
        .updateOrderItemDispenseStatusId(this.item.id, id)
        .then(({ data: { data: job } }) => {
          this.$store.commit('UPDATE_JOB_IN_JOBS', job);
        });
    },
    onOutletChange(id) {
      const outlet = this.selectableOutlets.find(o => o.id === id);

      this.item.outlet = outlet;

      apiOrders.updateOrderItemsDispenseOutletId([this.item.id], id).then(() => {
        this.$store.commit('UPDATE_JOB_IN_JOBS', this.order);
      });
    },
    openActivityHistory() {
      this.$root.$emit('openActivityHistory', {
        orderItemId: this.item.id,
        productName: this.productName,
        timezone: this.getTimeZone(this.order),
      });
    },
    openCommentsModal(orderItem) {
      const { customer } = this.order;
      const invoiceNumber = this.invoice;
      let title = this.getCustomerName(customer);
      title += invoiceNumber ? ` — ${invoiceNumber}` : '';
      title += this.productName ? ` — ${this.productName}` : '';
      this.$store.commit('commentModal/SHOW_COMMENT_MODAL', {
        vm: this,
        title,
        createCommentsCallback: noteContent =>
          apiNotes.createOrderItemNote(orderItem.id, this.currentUser.id, noteContent).then(() => {
            this.$root.$emit('reloadExpandedJob', this.order.id);
          }),
        fetchCommentsCallback: () => apiNotes.getOrderNotes(orderItem.id, 'orderItem'),
        removeCommentCallback: noteId =>
          apiNotes.deleteOrderNote(orderItem.id, noteId, 'orderItem'),
        timezone: this.getTimeZone(this.order),
      });
    },
    handleSelectItemChange() {
      this.setSelectedOrderItems({ ...this.item, customer: this.order.customer });
    },
    handleViewFile() {
      this.setSelectedPrescription(this.prescription.detail);
      this.setSelectedFile(this.file);
      this.$bvModal.show('file-modal');
    },
    async handleViewFileContactLensPrescription() {
      const prescriptionImage = this.hasContactLensPrescriptionFile;

      // If prescriptionImage is already an object with file info, use it directly
      if (typeof prescriptionImage === 'object' && prescriptionImage.file_name && prescriptionImage.full_path) {
        this.setSelectedFile(prescriptionImage);
        this.$bvModal.show('file-modal');
        return;
      }

      // Otherwise fetch file info by ID first
      this.loading = true;
      const fileId = typeof prescriptionImage === 'object' ? prescriptionImage.id : prescriptionImage;

      try {
        const { data } = await apiOrders.getContactLensPrescriptionFile(fileId);
        const fileInfo = data.data || data;
        this.setSelectedFile(fileInfo);
        this.$bvModal.show('file-modal');
      } catch (error) {
        console.error('Failed to load prescription file:', error);
      } finally {
        this.loading = false;
      }
    },
    getCustomerEmail() {
      const customerEmail = this._.get(this.order, 'customer.email');
      if (customerEmail) {
        return customerEmail;
      }
      // Guest
      const { customer_email = '' } = this.order.order_billing || {};
      return customer_email || 'the customer';
    },
  },
};
</script>

<style scoped>
.part-selection {
  line-height: 24px;
}

.part-selection__dot {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  text-transform: uppercase;
}

.part-selection__dot--black {
  background-color: #414347;
  color: #fff;
}

.part-selection__dot--white {
  border: 2px solid #ebeef4;
  background-color: #fff;
  color: #414347;
  line-height: 20px;
}

.part-selection__label {
  display: inline-block;
  vertical-align: middle;
  word-break: break-word;
}

.shape-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.shape-image {
  width: 50px;
  height: 50px;
  object-fit: contain;
}
</style>
